import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-empty-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empty-state.ui-component.html',
  styleUrl: './empty-state.ui-component.scss',
})
export class EmptyStateUiComponent {}
